// initialState.js

import { API } from "../../apis/api";

export const INITIAL_FORM_DATA = {
  companyName: "",
  shareholderName: "",
  claimantName: "",
  beneficiaryAccount: "",
  securityType: "",
  numberOfShares: "",
  shareFaceValue: "",
  folioId: "",
  dematId: "",
  SRN: "",
  transferDate: "",
  unclaimedSuspenseAccount: "",
  iepfRules: "",
  claimableAmount: "",
  signatureMismatch: "",
  securityMismatch: "",
  litigationPending: "",
  status: "",
  caseType: "",
  remark: "",
};

export const INITIAL_DIVIDEND_ENTRY = [{
  financialYear: "",
  paymentDate: "",
  warrantNo: "",
  amount: "",
}];

export const INITIAL_DOCUMENT_ENTRIES = [
  {
    documentType: "indemnity_bond",
    file: null,
    documentId: null,
    isUploading: false,
  },
  {
    documentType: "aadhar_card",
    file: null,
    documentId: null,
    isUploading: false,
  },
  {
    documentType: "pan_card",
    file: null,
    documentId: null,
    isUploading: false,
  },
];

export const INITIAL_NOTIFICATION = {
  open: false,
  message: "",
  severity: "info",
  key: 0,
};

export const getInitialDividendEntry = () => [
  {
    financialYear: "",
    paymentDate: "",
    warrantNo: "",
    amount: "",
  }
];

export const getInitialDocumentEntries = () => [
  {
    documentType: "indemnity_bond",
    file: null,
    documentId: null,
    isUploading: false,
  },
  {
    documentType: "aadhar_card",
    file: null,
    documentId: null,
    isUploading: false,
  },
  {
    documentType: "pan_card",
    file: null,
    documentId: null,
    isUploading: false,
  },
   {
    documentType: "share_certificate",
    file: null,
    documentId: null,
    isUploading: false,
  },
];

export const getChecklistMappings = async (checklistId,userId) => {
  try {
    const response = await API.post(
      "/ticket/document-checklist-mapping/",
      { checklist_id: checklistId,sub:userId }
    );

    return response?.data?.data?.mappings || [];
  } catch (error) {
    throw new Error("Error fetching mappings: ", error.message);
  }
};

export const buildDocumentEntries = (mappings) => {
  const baseDocs = [
    {
      documentType: "aadhar_card",
      file: null,
      documentId: null,
      fileName: null,
      filePath: null,
      isUploading: false,
      isMandatory: true,
    },
  ];

  const apiDocs = mappings
    .filter((doc) => doc.is_mandatory && doc.document_name !== "aadhar_card")
    .map((doc) => ({
      documentType: doc.document_name,
      file: null,
      documentId: null,
      fileName: null,
      filePath: null,
      isUploading: false,
      isMandatory: doc.is_mandatory,
    }));

  return [...baseDocs, ...apiDocs];
};

export const buildAvailableDocTypes = (mappings) => {
  if (!Array.isArray(mappings)) {
    throw new Error("Invalid API response structure.");
  }

  const mappedDocs = mappings.map((doc) => ({
    label: doc.document_name,
    value: doc.document_name,
    required: doc.is_mandatory,
  }));

  return [...mappedDocs, { label: "Other", value: "other", required: false }];
};